import { Fragment } from 'react';
import { Week } from './Week';
import { useCalendar } from '../../Context';
import { DatePickerBody, Weekday, Weekdays } from '../../styled';
import { deriveWeeks, getWeekdays } from '../../utils';
export function DatePicker() {
    const { locale, timeZone, weekStartsOn, focusedDate } = useCalendar();
    const weekdayFormat = new window.Intl.DateTimeFormat(locale, {
        weekday: 'short',
        timeZone,
    });
    const weeks = deriveWeeks({ date: focusedDate, weekStartsOn });
    const weekdays = getWeekdays({ date: focusedDate, weekStartsOn });
    return (<Fragment>
      <Weekdays>
        {weekdays.map((weekday) => (<Weekday key={weekday.toString()}>{weekdayFormat.format(weekday)}</Weekday>))}
      </Weekdays>
      <DatePickerBody>
        {weeks.map((week) => (<Week key={week.toString()} date={week}/>))}
      </DatePickerBody>
    </Fragment>);
}
